@if ({product: product$ | async, shippingInformation: shippingInformation$ | async}; as productAndShippingInfo) { @if
(shouldDisplayLeadTime$ | async) {
<h-lead-time [showBackground]="showLeadTimeBackground" [product$]="product$"></h-lead-time>
} @if (productAndShippingInfo.shippingInformation !== null && (shouldDisplayShippingInformation$ | async)) {
<h-shipping-information
    [showBackground]="showShippingInformationBackground"
    [shippingInformation]="productAndShippingInfo.shippingInformation"></h-shipping-information>
} @if (productAndShippingInfo.product !== null && (shouldDisplayShippingDelay$ | async)) {
<h-shipping-delay-message
    [product]="castToProductOrBasketItem(productAndShippingInfo.product)"></h-shipping-delay-message>
} }
